<template>
  <div class="container">
    <div class="f f-h f-ac f-sb m-bx4">
      <template v-if="isCurrentUser">
        <donut-page-title title="Profile" />
      </template>
      <template v-else>
        <a class="f-h f-ac c-p link" @click="goBackToProfilePage">
          <i class="mi md-18 m-rx1 bold">arrow_back</i>
          <div class="t-lg bold">Back to my profile</div>
        </a>
      </template>
      <donut-selex-users
        :exclude-guests="true"
        placeholder="Search employee profiles"
        :update-action="goToUserProfile"
      />
    </div>
    <div v-if="profileUser && profileEntries?.length">
      <div class="profile-container">
        <user-profiles--card />
      </div>
      <user-profiles-user-badges
        v-if="state.userProfileFields.userBadges && state.userProfileFields.userBadges.length > 0"
        :user-badges="state.userProfileFields.userBadges"
        :all-badges="state.userProfileFields.badges"
        class="card surface m-tx2"
      />
      <user-profiles--empty-profile-banner
        v-if="isCurrentUser && areAllEntriesEmpty"
        class="m-tx2"
        @edit-profile="openEditProfileModal"
      />
      <user-profiles--about-me
        class="m-tx2"
      />
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const { state, getters, commit } = useStore();

const profileUser = computed(() => state.userProfileFields.profileUser);
const profileEntries = computed(() => state.userProfileFields.profileEntries);

const isCurrentUser = computed(() => state.currentUser.id === profileUser.value?.id);

const areAllEntriesEmpty = computed(() => getters['userProfileFields/areAllEntriesEmpty']);

const openEditProfileModal = () => {
  commit('updateModal', {
    visible: true,
    size: 'xxl h-90vh of-x-h',
    subcomponent: 'user-profiles-modals-edit-profile',
    dismissable: false,
    data: {
      profileUser: profileUser.value,
      profileEntries: profileEntries.value,
      profileCategoryMachineNames: state.userProfileFields.profileCategoryMachineNames,
    },
  });
};

const goBackToProfilePage = () => {
  window.location = `/users/${state.currentUser.id}/profile`;
};

const goToUserProfile = (val, _option) => {
  window.donut.track('User Profiles - User searched for profile', {
    user_id: val,
  });
  window.location = `/users/${val}/profile`;
};
</script>

<style scoped lang="scss">
  .profile-container {
    position: relative;
  }
</style>
